import React from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import { NumericFormat as NumberFormat } from "react-number-format";
import { productoActions } from "../../_actions";
import cartService from "../../_services/cart/cart.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import authService from "../../_services/cart/authService";
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";
import {
  ErrorMessage,
  history,
  LoadingBoton,
  MEDIO_PAGO,
  TIPO_ENVIO,
} from "../../_helpers";
import { Radio, RadioGroup } from "react-radio-group";
import { Link } from "react-router-dom";
import { FastField, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import vendedorService from "../../_services/cart/vendedor.service";
import { busquedaActions } from "../../_actions/busqueda.actions";
import { productoService } from "../../_services";
import productoServiceTs from "../../_services/cart/producto.service";
import { CartelOferta, PrecioTachado, precioVigente } from "./utils/Oferta";

const bagRef = React.createRef();

class CheckoutPage extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  state = {
    appName: process.env.PUBLIC_URL,
    loading: false,
    submitted: false,
    showWallet: false,
    preferenceId: undefined,
    successCash: false,
    compraExitosa: false,
    provincias: [],
    tiposEnvios: [
      { id: TIPO_ENVIO.SIN_ENVIO, nombre: "Sin Envio" },
      {
        id: TIPO_ENVIO.ENVIO_A_COORDINAR,
        nombre: "Envio a coordinar con el vendedor",
      },
    ],
  };

  componentDidMount() {
    const vendedorMPKey = cartService.getMpKey();
    //TODO user la del vendedor.
    if (!!vendedorMPKey) initMercadoPago(vendedorMPKey);
    vendedorService.getProvincias(this.setProvincias);
  }

  buscarImagenes = (prod) => {
    if (prod.imagenes && prod.imagenes.length > 0) {
      return prod.imagenes;
    } else {
      if (
        !!prod.productoBaja &&
        prod.productoBaja.imagenes &&
        prod.productoBaja.imagenes.length > 0
      ) {
        return prod.productoBaja.imagenes;
      } else {
        return [{ url: this.state.appName + "/images/banner-bg.jpg", type:'image/jpeg'}];
      }
    }
  };

  setProvincias = (provincias) => {
    this.setState({ provincias: provincias });
  };

  onPreferenceSuccess = (response) => {
    this.setState({
      loading: false,
      preferenceId: response.preferenceId,
      showWallet: response.showWallet,
    });
  };

  onCompraCashSuccess = (response) => {
    this.setState({
      loading: false,
      successCash: response.successCash,
      compraId: response.compraId,
      compraExitosa: true,
    });

    window.scrollTo(0, 0);
  };

  /** Sin esto el boton quedaba deshabilitado para siempre si el POST fallaba. */
  onCompraError = () => {
    this.setState({ loading: false, submitted: false });
  };

  comprar = (values) => {
    // El total y el medio de pago se guardan ahora: al volver el POST el carrito
    // ya se vacio y no habria de donde sacarlos para el resumen final.
    this.setState({
      loading: true,
      submitted: true,
      totalCompra: cartService.getTotal(),
      medioPagoCompra: values.medioPago,
    });

    if (
      values.medioPago === MEDIO_PAGO.TRANSFERENCIA ||
      values.medioPago === MEDIO_PAGO.EFECTIVO
    ) {
      this.generarCompraCash(values);
    } else {
      this.generarPreference(values);
    }
  };

  onLoginSuccess = () => {
    history.push("/checkout");
  };

  generarPreference = (values) => {
    cartService.crearPreferencia(values, this.onPreferenceSuccess, this.onCompraError);
  };

  generarCompraCash = (values) => {
    cartService.crearCompraCash(values, this.onCompraCashSuccess, this.onCompraError);
  };

  render() {
    const { loading, compraExitosa, tiposEnvios } = this.state;

    let inic = {};

    let algunProductoTieneEnvio = cartService.algunProductoTieneEnvio();

    if (authService.isAuthenticated()) {
      inic = {
        direccion: authService.getLoggedUserDetail()?.direccion ?? "",
        ciudad: authService.getLoggedUserDetail()?.ciudad ?? "",
        // Sin provincia va undefined: con "" Yup.object() falla al castear.
        provincia: authService.getLoggedUserDetail()?.provincia ?? undefined,
        codigoPostal: authService.getLoggedUserDetail()?.codigoPostal ?? "",
        tipoEnvio: algunProductoTieneEnvio
          ? TIPO_ENVIO.ENVIO_A_COORDINAR
          : TIPO_ENVIO.SIN_ENVIO,
      };
    }

    const validationSchema = Yup.object().shape({
      medioPago: Yup.string().required("Requerido").label("Medio Pago"),
      ciudad: Yup.string().max(100, "Maximo 100 caracteres").label("Ciudad"),
      direccion: Yup.string()
        .max(100, "Maximo 100 caracteres")
        .label("Direccion"),
      /*
       * El Select guarda la provincia entera ({id, nombre}), que es lo que espera
       * IdDto.provincia en el backend. Declararla como string hacia que Yup tirara
       * "Provincia must be a string type" apenas se elegia una.
       */
      // id nullable: a quien no cargo provincia en el perfil el back le manda {id: null}, y
      // Yup.number() lo rechazaba sin mostrar error (el campo no tiene ErrorMessage): el boton
      // "Finalizar compra" quedaba muerto.
      provincia: Yup.object()
        .shape({ id: Yup.number().nullable() })
        .nullable()
        .label("Provincia"),
      codigoPostal: Yup.string()
        .max(100, "Maximo 100 caracteres")
        .label("Codigo Postal"),
    });

    const customSelect = {
      control: (provided) => ({
        // class attribute : class=" css-i32vvf-control"
        ...provided,
        background: "transparent",
        display: "flex",
        flexWrap: "nowrap",
        borderColor: "hsl(0deg 0% 80%);",
        width: "100%",
        height: "48px",
      }),
    };

    const handleRadioChange = (event) => {
      const radios = document.querySelectorAll(".checkout__product-payType");
      radios.forEach((radio) => radio.classList.remove("selected"));
      event.target
        .closest(".checkout__product-payType")
        .classList.add("selected");
    };

    document
      .querySelectorAll(".checkout__product-payType input[type='radio']")
      .forEach((radio) => {
        radio.addEventListener("change", handleRadioChange);
      });

    return (
      <>
        <main>
          <div className="container__dap">
            {compraExitosa && (
              <div className="checkout__exito">
                <div className="checkout__exito-icono">
                  <FontAwesomeIcon icon="fa-solid fa-circle-check" />
                </div>

                <h2>¡Listo! Tu compra está registrada</h2>
                <p className="checkout__exito-bajada">
                  Ya le avisamos al vendedor. Vas a poder seguir el estado desde
                  Mis compras.
                </p>

                <dl className="checkout__exito-datos">
                  <div>
                    <dt>N° de compra</dt>
                    <dd className="checkout__exito-id">
                      #{this.state.compraId}
                    </dd>
                  </div>
                  <div>
                    <dt>Total</dt>
                    <dd>
                      <NumberFormat
                        prefix={"$ "}
                        value={this.state.totalCompra}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </dd>
                  </div>
                  <div>
                    <dt>Medio de pago</dt>
                    <dd>
                      {this.state.medioPagoCompra === MEDIO_PAGO.TRANSFERENCIA
                        ? "Transferencia"
                        : "Efectivo"}
                    </dd>
                  </div>
                </dl>

                <div className="checkout__exito-pasos">
                  <h3>Qué sigue</h3>
                  <ol>
                    {this.state.medioPagoCompra ===
                    MEDIO_PAGO.TRANSFERENCIA ? (
                      <>
                        <li>
                          Entrá al detalle de la compra: ahí están el alias y el
                          CBU del vendedor.
                        </li>
                        <li>Hacé la transferencia por el total.</li>
                        <li>
                          Subí el comprobante desde el detalle. El vendedor
                          recibe un aviso apenas lo cargues.
                        </li>
                      </>
                    ) : (
                      <>
                        <li>Coordiná con el vendedor cómo pagar y retirar.</li>
                        <li>
                          El vendedor marca la compra como pagada cuando reciba
                          el dinero.
                        </li>
                      </>
                    )}
                  </ol>
                </div>

                <div className="checkout__exito-acciones">
                  {this.state.compraId && (
                    <Link
                      className="button"
                      data-type="primary"
                      to={
                        "/comprador/compraDetail?id=" + this.state.compraId
                      }
                    >
                      Ver el detalle de la compra
                    </Link>
                  )}
                  <Link
                    className="button"
                    data-type="complementary"
                    to={"/comprador/misCompras"}
                  >
                    Mis compras
                  </Link>
                  <Link className="button" data-type="complementary" to={"/home"}>
                    Seguir comprando
                  </Link>
                </div>
              </div>
            )}
            {!compraExitosa && (
              <>
                <h2 className="margin-block-10">
                  Detalle de pedido y método de pago
                </h2>
                <div className="even-columns">
                  <div className="checkout__content-main">
                    <h3>Tu pedido</h3>
                    <div className="dap-container">
                      {cartService.getCartSize() == 0 && (
                        <div className="checkout__product-item box-shadow-1">
                          No hay ningun producto en el carrito.
                        </div>
                      )}
                      {cartService.getCartProducts()?.map((product, idx) => (
                        <div
                          className="checkout__product-item box-shadow-1"
                          key={product.id}
                        >
                          <div className="checkout__product-item-infoWrapper">
                            <div className="checkout__product-item-image">
                              <img src={this.buscarImagenes(product)[0].url} />
                            </div>
                            <div className="checkout__product-item-info">
                              <div className="checkout__product-header">
                                <div className="checkout__product-title">
                                  <Link
                                    className="card__large-image"
                                    to={productoServiceTs.crearUrlProducto(product)}
                                    onClick={() =>
                                      this.props.seleccionarProducto(product)
                                    }
                                  >
                                    <h4>{product.tipoRepuesto.nombre}</h4>
                                  </Link>
                                </div>
                                <div className="checkout__product-price">
                                  <PrecioTachado oferta={product.oferta} />
                                  <NumberFormat
                                    prefix={"$"}
                                    value={precioVigente(product)}
                                    displayType={"text"}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                  />
                                </div>
                              </div>
                              <div className="checkout__product-body">
                                <div className="even-columns">
                                  <div>
                                    <p>
                                      Marca: <span>{product.marca.nombre}</span>
                                    </p>
                                    <p>
                                      Modelo:{" "}
                                      <span>{product.modelo.nombre}</span>
                                    </p>
                                    <p>
                                      Versión:{" "}
                                      <span>{product.version.nombre}</span>
                                    </p>
                                    {product.anio && (
                                      <p>
                                        Año: <span>{product.anio}</span>
                                      </p>
                                    )}
                                  </div>
                                  <div className="quantity">
                                    {/* <p>
                                                                            Cantidad: <span>1</span>
                                                                        </p> */}
                                    <p>
                                      {product.tipoEnvio ===
                                        TIPO_ENVIO.ENVIO_A_COORDINAR &&
                                        productoActions.esComprable(
                                          product
                                        ) && (
                                          <div className="delivery--right">
                                            Con envio &nbsp;
                                            <FontAwesomeIcon icon="fa-solid fa-truck" />
                                          </div>
                                        )}
                                    </p>
                                    <p
                                      className="delete"
                                      onClick={() =>
                                        cartService.remove(product)
                                      }
                                    >
                                      Eliminar
                                    </p>
                                  </div>
                                </div>

                                {/*
                                  Que oferta le bajo el precio a ESTE renglon, con su letra chica.
                                  Va por renglon y no una sola vez al pie: dos piezas del mismo
                                  carrito pueden estar en promociones distintas, y un "descuento"
                                  suelto en el total no dice cual es cual.
                                */}
                                <CartelOferta oferta={product.oferta} compacto />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {cartService.getCartSize() > 0 && (
                    <div className="checkout__content-main">
                      <h3>Detalle</h3>
                      <div className="dap-container">
                        <div className="checkout__product-payDetail">
                          <span>Subtotal</span>
                          <span>
                            <NumberFormat
                              prefix="$"
                              value={cartService.getTotalLista()}
                              displayType={"text"}
                              thousandSeparator="."
                              decimalSeparator=","
                            />
                          </span>
                        </div>

                        {/*
                          El descuento como renglon propio y no restado en silencio del total: si el
                          carrito solo mostrara el numero final, el ahorro —que es la razon por la
                          que la persona esta comprando hoy— no se veria en ningun lado.
                        */}
                        {cartService.getAhorro() > 0 && (
                          <div className="checkout__product-payDetail checkout__product-payDetail--descuento">
                            <span>Descuento por ofertas</span>
                            <span>
                              -
                              <NumberFormat
                                prefix="$"
                                value={cartService.getAhorro()}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                              />
                            </span>
                          </div>
                        )}
                        {/*<div className="checkout__product-payDetail">
                        <span>Costo de envío</span>
                        <span>AR $ 000.000.-</span>
                      </div>
                      <div className="checkout__product-payDetail">
                        <span>Descuento</span>
                        <span>AR $ 000.000.-</span>
                      </div> */}
                        <div className="checkout__product-payDetail--total">
                          <span>Total</span>
                          <span>
                            <NumberFormat
                              prefix="$"
                              value={cartService.getTotal()}
                              displayType={"text"}
                              thousandSeparator="."
                              decimalSeparator=","
                            />
                          </span>
                        </div>
                      </div>

                      {cartService.getTotal() > 0 &&
                        authService.isAuthenticated() && (
                          <Formik
                            enableReinitialize={true}
                            validationSchema={validationSchema}
                            initialValues={inic}
                            onSubmit={(values) => {
                              this.comprar(values);
                            }}
                          >
                            {({
                              errors,
                              touched,
                              values,
                              setFieldValue,
                              submitForm,
                              isValid,
                            }) => (
                              <Form>
                                {algunProductoTieneEnvio && (
                                  <>
                                    <h3>Envio</h3>
                                    <div className="dap-container">
                                      <div className="checkout__product-item-delivery">
                                        <Select
                                          disabled={
                                            this.state.loading ||
                                            this.state.submitted
                                          }
                                          styles={customSelect}
                                          value={
                                            this.state.tiposEnvios
                                              ? this.state.tiposEnvios.find(
                                                  (option) =>
                                                    option.id ==
                                                    values.tipoEnvio
                                                )
                                              : ""
                                          }
                                          getOptionLabel={(option) =>
                                            `${option.nombre}`
                                          }
                                          getOptionValue={(option) => option.id}
                                          onChange={(so) => {
                                            setFieldValue(`tipoEnvio`, so.id);
                                          }}
                                          isSearchable={false}
                                          placeholder="Seleccione una"
                                          options={this.state.tiposEnvios}
                                        />
                                      </div>
                                    </div>

                                    {values.tipoEnvio !=
                                      TIPO_ENVIO.SIN_ENVIO && (
                                      <>
                                        <div className="dap-container">
                                          <div className="checkout__product-item-delivery">
                                            <span>
                                              El envio del producto se
                                              coordinará con el vendedor luego
                                              de realizada la compra.
                                            </span>
                                            <div className="even-columns">
                                              <div className="form-group">
                                                <label htmlFor="direccion">
                                                  Dirección
                                                </label>
                                                <FastField
                                                  disabled={
                                                    this.state.submitted
                                                  }
                                                  className="form-control"
                                                  name="direccion"
                                                  type="text"
                                                />
                                                <ErrorMessage
                                                  name={`direccion`}
                                                />
                                              </div>
                                              <div className="form-group">
                                                <label htmlFor="codigoPostal">
                                                  Codigo Postal
                                                </label>
                                                <FastField
                                                  disabled={
                                                    this.state.submitted
                                                  }
                                                  className="form-control"
                                                  name="codigoPostal"
                                                  type="text"
                                                />
                                                <ErrorMessage
                                                  name={`codigoPostal`}
                                                />
                                              </div>
                                            </div>
                                            <div className="even-columns">
                                              <div className="form-group">
                                                <label htmlFor="ciudad">
                                                  Ciudad
                                                </label>
                                                <FastField
                                                  disabled={
                                                    this.state.submitted
                                                  }
                                                  className="form-control"
                                                  name="ciudad"
                                                  type="text"
                                                />
                                                <ErrorMessage name={`ciudad`} />
                                              </div>
                                              <div className="form-group">
                                                <label htmlFor="provincia">
                                                  Provincia
                                                </label>
                                                <Select
                                                  disabled={
                                                    this.state.submitted
                                                  }
                                                  styles={customSelect}
                                                  value={
                                                    this.state.provincias
                                                      ? this.state.provincias.find(
                                                          (option) =>
                                                            option.id ==
                                                            values.provincia?.id
                                                        )
                                                      : ""
                                                  }
                                                  getOptionLabel={(option) =>
                                                    `${option.nombre}`
                                                  }
                                                  getOptionValue={(option) =>
                                                    option.id
                                                  }
                                                  onChange={(so) => {
                                                    setFieldValue(
                                                      `provincia`,
                                                      so
                                                    );
                                                  }}
                                                  isSearchable={false}
                                                  placeholder="Seleccione una"
                                                  options={
                                                    this.state.provincias
                                                  }
                                                />
                                                <ErrorMessage
                                                  name={`provincia`}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}

                                <h3>Medios de pago disponibles</h3>
                                <div className="dap-container">
                                  <div className="even-columns--checkout">
                                    <RadioGroup
                                      disabled={this.state.submitted}
                                      name="medioPago"
                                      selectedValue={values.medioPago}
                                      onChange={(event) =>
                                        setFieldValue("medioPago", event)
                                      }
                                    >
                                      {cartService.tieneMercadoPago() && (
                                        <div className="checkout__product-payType">
                                          <Radio
                                            value={MEDIO_PAGO.MERCADO_PAGO}
                                          />
                                          <span>Mercado Pago</span>
                                          <img
                                            className="mp-logo"
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/images/mp-logo.png"
                                            }
                                            width="80"
                                            height="auto"
                                            alt="Mercado Pago"
                                          />
                                        </div>
                                      )}
                                      <div className="checkout__product-payType">
                                        <Radio
                                          value={MEDIO_PAGO.TRANSFERENCIA}
                                        />
                                        <span>Por Transferencia</span>
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-right-left"
                                          size="lg"
                                        />
                                      </div>
                                      <div className="checkout__product-payType">
                                        <Radio value={MEDIO_PAGO.EFECTIVO} />
                                        <span>En Efectivo </span>
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-money-bill-wave"
                                          size="lg"
                                        />
                                      </div>
                                    </RadioGroup>
                                    <ErrorMessage name={`medioPago`} />
                                  </div>
                                </div>

                                <div className="dap-container">
                                  <div className="checkout__product-payment">
                                    {!this.state.showWallet && (
                                      <>
                                        <button
                                          className="button checkout__finalizar"
                                          type="submit"
                                          data-type="primary"
                                          disabled={loading || this.state.submitted}
                                        >
                                          {loading && (
                                            <FontAwesomeIcon
                                              icon="fa-solid fa-circle-notch"
                                              spin
                                            />
                                          )}
                                          {loading
                                            ? "Procesando compra…"
                                            : "Finalizar Compra"}
                                        </button>
                                        {loading && (
                                          <p className="checkout__procesando">
                                            Estamos registrando tu compra y
                                            avisándole al vendedor. No cierres ni
                                            recargues esta página.
                                          </p>
                                        )}
                                      </>
                                    )}

                                    {this.state.showWallet && (
                                      <>
                                        <p>
                                          Compra procesada, ahora podes proceder
                                          a completar tu pago en Mercado Pago:
                                        </p>
                                        <Wallet
                                          onSubmit={() => cartService.clear()}
                                          initialization={{
                                            redirectMode: "self",
                                            preferenceId:
                                              this.state.preferenceId,
                                          }}
                                        />
                                      </>
                                    )}


                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        )}

                      {!authService.isAuthenticated() && (
                        <div className="dap-container">
                          <div className="checkout__product-payment">
                            <Button
                              className="button"
                              data-type="complementary"
                              type="button"
                              onClick={() => {
                                authService.goToLoginAndSetOnLoginSuccess(
                                  "/checkout"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon="fa-solid fa-lock" />{" "}
                              Iniciar Sesión Y Finalizar Compra
                            </Button>
                            <span className="checkout__product-payment--loginAdvise">
                              Debes iniciar sesión para proceder a pagar
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </main>
      </>
    );
  }
}

function mapState(state) {
  let value = state.producto.value;
  return { value };
}

const actionCreators = {
  seleccionarProducto: busquedaActions.seleccionarProducto,
};

const connectedCheckoutPage = connect(mapState, actionCreators)(CheckoutPage);
export { connectedCheckoutPage as CheckoutPage };
